import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import CreateItem from './pages/CreateItem';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import Discover from './pages/Discover';
import ItemDetail from "./pages/ItemDetail";
import ClaimSPToken from './pages/ClaimSPToken';
import ClaimPaymentToken from './pages/ClaimPaymentToken';
import Liquidity from './pages/Liquidity';
import { ChakraProvider } from '@chakra-ui/react';
// import DiscoverTwo from './pages/DiscoverTwo';
// import ArticleStyleTwo from './pages/ArticleStyleTwo';
// import AuthorPage from './pages/AuthorPage';
// import Authors from './pages/Authors';
// import Collection from './pages/Collection';
// import FAQ from './pages/FAQ';
// import ItemStyle from './pages/ItemStyle';
// import BlogStyleTwo from './pages/BlogStyleTwo';
import { AuthProvider } from "./contexts/AuthContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<StrictMode>
	<ChakraProvider>
		<AuthProvider>
			<BrowserRouter>
			<Routes>
			<Route path="/" element={<Discover type={4} />} />
				<Route exact path="/create" element={<CreateItem />} />
				<Route path="/onsale" element={<Discover type={0} />} />
				<Route path="/myonsale" element={<Discover type={1} />} />
				<Route path="/unlisted" element={<Discover type={5} />} />
				<Route path="/myunlisted" element={<Discover type={3} />} />
				<Route path="/all" element={<Discover type={4} />} />
				<Route path="/id/:tokenId" element={<ItemDetail />} />
				<Route path="/claimsptoken/:tokenId" element={<ClaimSPToken />} />
				<Route path="/claimpayment" element={<ClaimPaymentToken />} />
				<Route path="/liquidity" element={<Liquidity />} />
				
				{/* <Route exact path="/discover2" element={<DiscoverTwo />} />
				<Route exact path="/articlestyle2" element={<ArticleStyleTwo />} />
				<Route exact path="/author-page" element={<AuthorPage />} />
				<Route exact path="/authors" element={<Authors />} />
				<Route exact path="/collection" element={<Collection />} />
				<Route exact path="/faq" element={<FAQ />} />
				<Route exact path="/itemstyle" element={<ItemStyle />} />
				<Route exact path="/blog-style2" element={<BlogStyleTwo />} /> */}
			</Routes>
			</BrowserRouter>
		</AuthProvider>
	</ChakraProvider>
</StrictMode>
);